import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Import Containers
import { DefaultLayoutComponent } from './containers';
import { AuthGuard } from './helper/auth.guard';

import { P404Component } from './views/error/404.component';
import { P500Component } from './views/error/500.component';
import { LoginComponent } from './views/login/login.component';
import { LogoutSystemComponent } from './views/login/logout-system/logout-system.component';


export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: '404',
    component: P404Component,
    data: {
      title: 'Page 404'
    }
  },
  {
    path: '500',
    component: P500Component,
    data: {
      title: 'Page 500'
    }
  },
  {
    path: 'logout-system',
    component: LogoutSystemComponent,
    data: {
      title: 'Close System'
    }
  },
  {
    path: 'not-intruders/:valueEncpt/:boToken',
    component: LoginComponent,
    data: {
      title: 'Login Page'
    }
  }
  ,
  {
    path: '',
    component: DefaultLayoutComponent,
    data: {
      title: 'Home'
    },
    children: [
      // {
      //   path: 'base',
      //   loadChildren: () => import('./views/base/base.module').then(m => m.BaseModule)
      // },
      {
        path: 'dashboard',
        loadChildren: () => import('./views/dashboard/dashboard.module').then(m => m.DashboardModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'reportes',
        loadChildren: () => import('./views/reportes/reportes.module').then(m => m.ReportesModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'clientes',
        loadChildren: () => import('./views/clientes/clientes.module').then(m => m.ClientesModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'cre',
        loadChildren: () => import('./views/cre/cre.module').then(m => m.CreModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'garantia',
        loadChildren: () => import('./views/garantias/garantias.module').then(m => m.GarantiasModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'usuario',
        loadChildren: () => import('./views/usuario/usuario.module').then(m => m.UsuarioModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'afiliado',
        loadChildren: () => import('./views/afiliado/afiliado.module').then(m => m.AfiliadoModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'caja',
        loadChildren: () => import('./views/caja/caja.module').then(m => m.CajaModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'administracion',
        loadChildren: () => import('./views/configuraciones/configuraciones.module').then(m => m.ConfiguracionesModule),
        canActivate: [AuthGuard]
      }
    ]
  },
  { path: '**', component: P404Component }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
